import React from "react";
import { MdOutlineLanguage } from "react-icons/md";
import { UseLanguage } from "../../Hooks/UseLanguage";

const LangButton = () => {
  const { language, toggleLanguage } = UseLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="flex justify-center items-center gap-2 rounded-md border-2 border-lightBlue text-sm text-lighBlue font-bold pe-2 p-1">
      <MdOutlineLanguage />
      {language}
    </button>
  );
};

export default LangButton;
